export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11104.b79bc53e.jpg";